// extracted by mini-css-extract-plugin
export default {"subTitle":"SharedWithMe_subTitle__q9wCQ"};